import { render, staticRenderFns } from "./InvoiceDetailView.vue?vue&type=template&id=32cde0c6&"
import script from "./InvoiceDetailView.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports